import React, { useState, useEffect } from 'react';
import { Button } from 'types/ButtonTypes';
import { useTranslation } from 'react-i18next';
import { useAllowedRight } from 'services/permissions/permissionChecks';
import '../../style/scss/button.scss';
import '../../style/scss/tooltip.scss';

const PrimaryButton: React.FC<Button> = ({ 
    onClick, 
    label, 
    size = 'medium', 
    disabled,
    loading = false, 
    type = 'button', 
    onlyViewRestriction,
    customClass,
    tooltipText,
    icon
}) => {
    const { t } = useTranslation();

    // Make the button invisible if it is restricted for only_view users
    const userHasOnlyViewRight = !useAllowedRight('only_view')
    const isVisible = onlyViewRestriction ? userHasOnlyViewRight : true;

    // Set the size, button and text loading classes
    const buttonSizeClass = `button-${size}`;
    const buttonDisabledClass = disabled?.disabled ? 'button-disabled' : '';
    const buttonTooltipClass = (disabled?.disabled && disabled.message) || (tooltipText) ? 'tooltip-hover' : '';
    const buttonLoadingClass = loading ? 'button-loading' : '';
    const textLoadingClass = loading ? 'text-hidden' : '';

    // Give the loader icon a delay, so it looks smoother
    const [showLoaderWithDelay, setShowLoaderWithDelay] = useState(false);
    useEffect(() => {
        let timer: number;
        if (loading) {
            timer = window.setTimeout(() => setShowLoaderWithDelay(true), 150)
        } else {
            setShowLoaderWithDelay(false);
        }
        return () => clearTimeout(timer);
    }, [loading]);

    return (
        isVisible ? (
            <button type={type}
                    onClick={onClick}
                    className={`button ${buttonSizeClass} button-primary ${customClass} ${buttonLoadingClass} ${buttonDisabledClass} ${buttonTooltipClass}`}
                    disabled={loading || disabled?.disabled}>
                <span className={`button-text ${textLoadingClass}`}>
                    {t(label)}
                    {icon && (
                        <span className='button-icon'>
                            {icon}
                        </span>
                    )}
                </span>
                {tooltipText &&
                    <span className="tooltip">
                        {t(tooltipText)}
                    </span>
                }
                {showLoaderWithDelay && 
                    <div className={'loader-container'}>
                        <div className={'button-loader'}></div>
                    </div>
                }
                {disabled?.disabled && disabled?.message &&
                    <span className="tooltip">
                        {t(disabled.message)}
                    </span>
                }
            </button>
        ) : null
    );
};

export default PrimaryButton;